
let language = {
    "QP-MSG-TOOLTIP-MORE-TEXT": "More",
    "QP-MSG-TOOLTIP-CODE-TEXT": "code",
    "QP-MSG-TOOLTIP-DSC-TEXT": "reason",
};

export { language }